import { render, staticRenderFns } from "./EmployerOtherAgeRequirementMonthsInput.vue?vue&type=template&id=f2f5dedc&"
import script from "./EmployerOtherAgeRequirementMonthsInput.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherAgeRequirementMonthsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports